module.exports = __webpack_public_path__ + "static/media/Aqwas-Portfolio-Arabic.89db8c00.pdf";